import type { FC } from 'react';
import { cx } from '../../../utils/cx';
import { CloseButton } from '../buttons/close-button';
import { Button } from '../buttons/button';

export type AlertIconProps = {
  icon: FC<{ className?: string }>;
  iconClass: string;
  ringClass: string;
  className?: string;
};

export const AlertIcon: FC<AlertIconProps> = ({
  icon: Icon,
  iconClass,
  ringClass,
  className
}) => (
  <div className={cx('relative size-(--gn-spacing-2xl) shrink-0', className)}>
    <div
      className={cx(
        'absolute -inset-[45%] rounded-full border-2 opacity-10',
        ringClass
      )}
    />
    <div
      className={cx(
        'absolute -inset-[20%] rounded-full border-2 opacity-30',
        ringClass
      )}
    />
    <Icon className={cx('relative size-(--gn-spacing-2xl)', iconClass)} />
  </div>
);

export interface AlertCloseButtonProps {
  onClick?: () => void;
  className: string;
}

export const AlertCloseButton: FC<AlertCloseButtonProps> = ({
  onClick,
  className
}) => (
  <CloseButton
    className={cx(
      'hover:bg-inherit absolute top-(--gn-spacing-lg) right-(--gn-spacing-lg)',
      className
    )}
    onClick={onClick}
    aria-label="Close alert"
  />
);

export type AlertActionsProps = {
  dismissText?: string;
  onDismiss?: () => void;
  actionText?: string;
  onAction?: () => void;
  dismissClass: string;
  actionClass: string;
  className?: string;
};

export const AlertActions: FC<AlertActionsProps> = ({
  dismissText,
  onDismiss,
  actionText,
  onAction,
  dismissClass,
  actionClass,
  className
}) => {
  if (!dismissText && !actionText) return null;

  return (
    <div
      className={cx(
        'flex items-center gap-(--gn-spacing-lg) -m-(--gn-spacing-md)',
        className
      )}
    >
      {dismissText && (
        <Button
          color="tertiary"
          onClick={onDismiss}
          className={cx(dismissClass, 'px-(--gn-spacing-sm) hover:bg-inherit')}
        >
          {dismissText}
        </Button>
      )}
      {actionText && (
        <Button
          color="tertiary"
          onClick={onAction}
          className={cx(actionClass, 'px-(--gn-spacing-sm) hover:bg-inherit')}
        >
          {actionText}
        </Button>
      )}
    </div>
  );
};
